import styled from '@emotion/styled'
import { Moment } from 'moment'
import React, { FunctionComponent } from 'react'
import { UseFormSetValue } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TextArea } from '../../../../Common/TextInput'
import { AppointmentActivity } from '../../Inputs/AppointmentActivity'
import { AppointmentDateRangePicker } from '../../Inputs/AppointmentDateRangePicker'
import { AppointmentRecurrence } from '../../Inputs/AppointmentRecurrence'
import { CustomerSearch } from '../../Inputs/CustomerSearch'
import { HourPicker } from '../../Inputs/HourPicker'
import { ICrudActivityDetails } from '../../types/ICrudActivityDetails'
import { IAddedActivity } from '../AddActivityViewSwitch/IAddActivity'

export const ConditionalContainer = styled.div<{ isHidden: boolean }>`
  display: ${({ isHidden }) => (isHidden ? 'none' : 'block')};
`

interface IProps {
  isSelectViewOpen: boolean
  setValue: UseFormSetValue<any>
  appointmentMoment?: Moment
  watchIsRepeat: boolean
  watchRepeatOption: any
  selectedPersonName: string
  selectedActivityArray: IAddedActivity[]
  setSelectedActivityArray: (activities: ICrudActivityDetails) => void
  setSelectViewOpen: (viewSwitch: 'activity' | 'menu') => void
  setIsPanelFocus: (state: boolean) => void
}

export const CreateFormFields: FunctionComponent<IProps> = ({
  isSelectViewOpen,
  setValue,
  appointmentMoment,
  watchIsRepeat,
  watchRepeatOption,
  selectedPersonName,
  setSelectedActivityArray,
  selectedActivityArray,
  setSelectViewOpen,
  setIsPanelFocus,
}) => {
  const { t } = useTranslation()

  return (
    <ConditionalContainer isHidden={isSelectViewOpen}>
      <CustomerSearch setValue={setValue} setIsPanelFocus={setIsPanelFocus} />
      <AppointmentDateRangePicker
        setValue={setValue}
        appointmentMoment={appointmentMoment}
      />
      <HourPicker
        appointmentMoment={appointmentMoment}
        setValue={setValue}
        inputName="startHour"
      />
      <AppointmentRecurrence
        setValue={setValue}
        watchIsRepeat={watchIsRepeat}
        watchRepeatOption={watchRepeatOption}
      />
      <AppointmentActivity
        setSelectedActivityArray={setSelectedActivityArray}
        selectedActivityArray={selectedActivityArray}
        setSelectViewOpen={setSelectViewOpen}
        selectedPersonName={selectedPersonName}
      />
      <label htmlFor="notes">
        <span>{t('Appointment note')}</span>
        <TextArea
          id="notes"
          onChange={e => setValue('notes', e.target.value)}
          width={400}
        />
      </label>
    </ConditionalContainer>
  )
}
